export default __webpack_public_path__ + "static/media/cc12.71385bb8.png";